<agpr-dialog-container
    [id]="'postDistributionAmplifyDialog'"
    class="agpr-postDistributionAmplifyDialog"
    heading="Discover.amplify.postDistribution.header"
    [contentPadding]="false"
    (close)="close()"
>
    <agpr-scroll-panel>
        <div class="agpr-postDistributionAmplifyDialog-innerContent">
            <agpr-message
                *ngIf="isImmediate"
                class="agpr-amplifyMessage"
                icon="fa-regular fa-duotone fa-circle-check"
                [severity]="messageSeverity.success"
            >
                <p>
                    {{ 'Discover.amplify.postDistribution.distributionInfo.now' | localize: { name: distribution?.name } }}
                </p>
            </agpr-message>
            <agpr-message
                *ngIf="!isImmediate && scheduledDate"
                class="agpr-amplifyMessage"
                icon="fa-regular fa-duotone fa-circle-check"
                [severity]="messageSeverity.success"
            >
                <p>
                    {{ 'Discover.amplify.postDistribution.distributionInfo.scheduled' | localize: {
                        name: distribution?.name,
                        date: scheduledDate | date: dateFormat,
                    } }}
                </p>
            </agpr-message>

            <div class="agpr-boostHeading">
                <h3>{{'Discover.amplify.postDistribution.amplifyHeader' | localize}}</h3>
                <span [innerHtml]="'Discover.amplify.postDistribution.amplifyMessage.info' | localize"></span>
            </div>

            <!-- TODO: Add userHasNewsroomPermission to ngIf - NEP-13769-->
            <!-- <div class="agpr-postDistributionAmplifyDialog-amplify"> -->
                <!-- TODO: unhide once NEP-13769 is landed -->
                <!-- <agpr-button *ngIf="userHasNewsroomPermission && false" class="agpr-amplifyMessage-btn">
                    <div class="agpr-amplifyMessage-button">
                        <span class="agpr-amplifyMessage-button-icon">
                            <i class="agpr-i-line-bullhorn" aria-hidden="true"></i>
                        </span>
                        <div class="agpr-amplifyMessage-button-detail">
                            <span class="agpr-amplifyMessage-button-title">
                                {{ 'Discover.distributionReport.amplify.newsroom.heading' | localize }}
                            </span>
                            <p class="agpr-amplifyMessage-button-text">
                                {{ 'Discover.distributionReport.amplify.newsroom.text' | localize }}
                            </p>
                        </div>
                    </div>
                </agpr-button> -->

            <!-- </div> -->

            <agpr-panel
                *ngIf="userHasNewswirePermission"
                class="agpr-postDistributionAmplifyDialog-panel"
                [collapsed]="true"
            >
                <ng-template #panelHeader>
                    <div class="agpr-amplifyMessage-button">
                        <span class="agpr-amplifyMessage-button-icon fa-regular fa-duotone fa-globe" aria-hidden="true"></span>
                        <div class="agpr-amplifyMessage-button-detail">
                            {{ 'Discover.distributionReport.amplify.newswire.text' | localize }}
                        </div>
                    </div>
                </ng-template>
                <div class="agpr-postDistributionAmplifyDialog-message">
                    <div>
                        <span>{{'Discover.distributionReport.amplify.newswire.message.beforeLink' | localize}}</span>
                        <a href="https://www.agilitypr.com/newswire-provisioning-form/" target="_blank">{{'Discover.distributionReport.amplify.newswire.message.link' | localize}}</a>
                        <span>{{'Discover.distributionReport.amplify.newswire.message.afterLink' | localize}}</span>
                    </div>
                    <agpr-message
                        [severity]="messageSeverity.info"
                    >
                        {{'Discover.distributionReport.amplify.newswire.disclaimer' | localize}}
                    </agpr-message>
                </div>
            </agpr-panel>

            <agpr-panel
                *ngIf="userHasBoostPermission && showBoost"
                class="agpr-postDistributionAmplifyDialog-panel"
                [collapsed]="true"
            >
                <ng-template #panelHeader>
                    <div class="agpr-amplifyMessage-button">
                        <span class="agpr-amplifyMessage-button-icon fa-regular fa-duotone fa-bolt" aria-hidden="true"></span>
                        <div class="agpr-amplifyMessage-button-detail">
                            {{ 'Discover.amplify.postDistribution.boostHeader' | localize }}
                        </div>
                    </div>
                </ng-template>

                <div class="agpr-postDistributionAmplifyDialog-message">
                    <div>{{ 'Distribution.onlineBoost.dialog.message' | localize }}</div>
                    <a
                        class="agpr-postDistributionAmplifyDialog-message-link"
                        href="http://help.agilitypr.com/en/articles/5679879-online-boost-service-faq"
                        target="_blank"
                    >{{'Discover.amplify.postDistribution.confirmAction.detail.link' | localize}}</a>
                </div>
                <div class="agpr-postDistributionAmplifyDialog-disclaimer">
                    <agpr-checkbox
                        id="disclaimerCheckbox"
                        [value]="doBoost"
                        (onChange)="doBoost = !doBoost"
                    >
                        <div class="agpr-postDistributionAmplifyDialog-disclaimer-text">{{'Discover.amplify.postDistribution.confirmAction.disclaimer' | localize}}</div>
                    </agpr-checkbox>
                    <agpr-button
                        class="agpr-postDistributionAmplifyDialog-confirm"
                        [style]="buttonTypes.tertiary"
                        label="Discover.amplify.postDistribution.confirm"
                        [disabled]="!doBoost"
                        (click)="setAmplifications()"
                    ></agpr-button>
                </div>

            </agpr-panel>
        </div>
    </agpr-scroll-panel>


    <ng-container>
        <ng-template #footerLeft>
            <agpr-button
                id="cancelButton"
                label="close"
                (click)="close()"
            ></agpr-button>
        </ng-template>
    </ng-container>

</agpr-dialog-container>
